import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule,
  ExtraOptions,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { EnvironmentGuard } from './core/guards/environment.guard';
import { DesktopLayoutComponent } from './core/layout/desktop-layout/desktop-layout.component';
import { MobileLayoutComponent } from './core/layout/mobile-layout/mobile-layout.component';
import { LayoutService } from './core/services/layout.service';

/*
  Routes declaration
  (Routes changes dynamically based on screen size)
*/

const desktopRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/shopify-auth/shopify-auth.module').then(
        (m) => m.ShopifyAuthModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'bots',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/bots/bots.module').then((m) => m.BotsModule),
  },
  {
    path: 'test',
    canLoad: [EnvironmentGuard],
    loadChildren: () =>
      import('./features/dev-test/dev-test.module').then(
        (m) => m.DevTestModule
      ),
  },
  {
    path: 'bot/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/bot/bot.module').then((m) => m.BotModule),
  },
  {
    path: '**',
    redirectTo: 'bots',
  },
];

const mobileRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/shopify-auth/shopify-auth.module').then(
        (m) => m.ShopifyAuthModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'bots',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/bots/bots.module').then((m) => m.BotsModule),
  },
  {
    path: 'test',
    canLoad: [EnvironmentGuard],
    loadChildren: () =>
      import('./features/dev-test/dev-test.module').then(
        (m) => m.DevTestModule
      ),
  },
  {
    path: 'bot/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/bot-mobile/bot-mobile.module').then(
        (m) => m.BotMobileModule
      ),
  },
  {
    path: '**',
    redirectTo: 'bots',
  },
];

const routes: Routes = [
  {
    path: '',
    component: DesktopLayoutComponent,
    children: [...desktopRoutes, ...mobileRoutes],
  },
];

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  private initFlag = false;
  constructor(
    private router: Router,
    private layoutService: LayoutService,
    private route: ActivatedRoute
  ) {
    layoutService.screenObserver.subscribe((isMobile) => {
      this.setRoutes(isMobile);
    });
  }
  private setRoutes(isMobile: boolean): void {
    if (isMobile) {
      const newRoutes = routes;
      newRoutes[0].component = MobileLayoutComponent;
      newRoutes[0].children = mobileRoutes;
      this.router.resetConfig(newRoutes);
    } else {
      const newRoutes = routes;
      newRoutes[0].component = DesktopLayoutComponent;
      newRoutes[0].children = desktopRoutes;
      this.router.resetConfig(newRoutes);
    }

    if (this.initFlag) {
      // alert('Redirect error');

      this.router.navigate([], { relativeTo: this.route });
    }
    this.initFlag = true;
  }
}
